var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegoHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BBE90B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.3,0H31.7c-1.7,0-3.1,1.4-3.1,3.1v11.6h42.6V3.1C71.3,1.4,69.9,0,68.3,0z M22.4,93.4h55.2v6.6H22.4V93.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.5,17.8h-59c-7.4,0-13.5,6-13.5,13.5v45.6c0,7.4,6,13.5,13.5,13.5h59c7.4,0,13.5-6,13.5-13.5V31.2 C92.9,23.8,86.9,17.8,79.5,17.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegoHead);
export default __webpack_public_path__ + "static/media/lego-head.46c5db417468843331de6412298bdd87.svg";
export { ForwardRef as ReactComponent };